<template>
  <div class="map-wrap">
    <div class="action-row-wrap">
      <div class="search-box">
        <el-input placeholder="请输入内容查询定位" v-model="loactionInputValue">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchGeoCode"
          ></el-button>
        </el-input>
      </div>
      <div>
        <el-button v-if="markerItems.length == 0" @click="addMarker">
          添加标记
        </el-button>
        <el-button @click="editMarker">启用编辑模式</el-button>
        <el-button @click="drawFinish">结束绘制</el-button>
        <el-button @click="resetCenter">复位</el-button>
      </div>
    </div>
    <div class="map-container" id="mapContainer"></div>
    <div class="map-footer">
      <div class="btn-box">
        <el-button @click="cancel">取消</el-button>
        <el-button @click="saveMarker">保存</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import * as cd from "coordtransform";
import "leaflet-draw/dist/leaflet.draw";
import "leaflet-draw/dist/leaflet.draw.css";
import drawIcon from "@/icons/map_marker_icon.png";
import editIcon from "@/icons/map_check_marker_icon.png";
import axios from "axios";
/**
 * wgs84togcj02
 * gcj02towgs84
 */
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    markerItems: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      map: null,
      loactionInputValue: "",
      center: [28.726514352584, 105.06375233065],
      subdomains: [0, 1, 2, 3, 4, 5, 6, 7],
      drawLayer: null,
      drawControl: null,
      locationData: "",
      tk: "49534f36b1e3ccba7baac6a27ebd2832",
      markerIcon: L.icon({
        iconUrl: drawIcon, // 设置图标的 URL
        iconSize: [24, 24], // 设置图标的大小
      }),
      markerEdittingIcon: L.icon({
        iconUrl: editIcon, // 设置图标的 URL
        iconSize: [24, 24], // 设置图标的大小
      }),
      emitLnglat: null,
    };
  },
  methods: {
    initMap() {
      this.map = L.map("mapContainer", {
        crs: L.CRS.EPSG4326,
        zoomControl: false,
        center: this.center,
        attributionControl: false,
        zoom: 13,
        maxZoom: 17,
      });
      const normalm = L.tileLayer(
        "http://t{s}.tianditu.gov.cn/vec_c/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=vec&tileMatrixSet=c&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=" +
          "49534f36b1e3ccba7baac6a27ebd2832",
        {
          subdomains: this.subdomains,
          maxZoom: 17,
          minZoom: 5,
          tileSize: 256,
          zoomOffset: 1,
        }
      );
      const normala = L.tileLayer(
        "http://t{s}.tianditu.gov.cn/cva_c/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=cva&tileMatrixSet=c&TileMatrix={z}&TileRow={y}&TileCol={x}&style=default&format=tiles&tk=" +
          "49534f36b1e3ccba7baac6a27ebd2832",
        {
          subdomains: this.subdomains,
          maxZoom: 17,
          minZoom: 5,
          tileSize: 256,
          zoomOffset: 1,
        }
      );
      const layer = L.layerGroup([normalm, normala]).setZIndex(1);
      this.map.addLayer(layer);
      this.drawLayer = new L.FeatureGroup();
      this.map.addLayer(this.drawLayer.setZIndex(2));
      this.initMarker();
    },
    // emitLnglat() {
    //   this.$emit("getLnglat", { lng: 120.345678, lat: 39.234567 });
    // },
    resetCenter() {
      this.map.setView(this.center, 13);
    },
    initMarker() {
      let MyCustomMarker = L.Icon.extend({
        options: {
          shadowUrl: null,
          // iconAnchor: new L.Point(12, 12),
          iconSize: new L.Point(24, 24),
          iconUrl: drawIcon,
        },
      });
      this.markerItems.forEach((item) => {
        console.log("item", item);
        const result = cd.gcj02towgs84(item.Longitude, item.Latitude);
        let wgsLng = result[0];
        let wgsLat = result[1];
        const marker = L.marker([Number(wgsLat), Number(wgsLng)], {
          icon: new MyCustomMarker(),
        });
        this.drawLayer.addLayer(marker);
      });
    },
    addMarker() {
      this.drawControl = new L.Control.Draw({
        draw: {
          //绘制线
          polyline: false,
          //绘制多边形
          polygon: false,
          //绘制矩形
          rectangle: false,
          //绘制圆
          circle: false,
          //绘制标注
          marker: {
            icon: this.markerIcon,
          },
          //绘制圆形标注
          circlemarker: false,
        },
        edit: {
          //绘制图层
          featureGroup: this.drawLayer,
          //图形编辑控件
          edit: false,
          //图形删除控件
          remove: false,
        },
      });
      this.map.addControl(this.drawControl);

      this.map.on(L.Draw.Event.CREATED, (e) => {
        const type = e.layerType;
        const layer = e.layer;
        if (type === "marker") {
          this.drawLayer.addLayer(layer);
        }
      });
    },
    editMarker() {
      let markerEdittingIcon = this.markerEdittingIcon;
      // let markerIcon = this.markerIcon;
      this.drawLayer.eachLayer(function (layer) {
        if (layer instanceof L.Marker) {
          // 方法 1: 在创建标记时启用拖拽
          // 假设你已经像这样添加了标记：L.marker([51.5, -0.1], { draggable: true }).addTo(markersGroup);

          // 方法 2: 对于已经存在的标记，启用拖拽功能
          layer.setIcon(markerEdittingIcon);
          layer.dragging.enable();

          // 可选：监听拖拽事件
          layer.on("dragend", function (event) {
            let marker = event.target;
            let position = marker.getLatLng();
            console.log("Marker dragged to:", position);
            // layer.setIcon(markerIcon);
            // marker.dragging.disable();
          });
        }
      });
    },
    drawFinish() {
      let markerIcon = this.markerIcon;
      let markers = [];
      this.drawLayer.eachLayer(function (layer) {
        if (layer instanceof L.Marker) {
          // 方法 1: 在创建标记时启用拖拽
          // 假设你已经像这样添加了标记：L.marker([51.5, -0.1], { draggable: true }).addTo(markersGroup);

          // 方法 2: 对于已经存在的标记，启用拖拽功能
          layer.setIcon(markerIcon);
          layer.dragging.disable();
          markers.push(layer);
        }
      });
      let markerLnglat = markers[0].getLatLng();
      console.log("markerLnglat", markerLnglat);
      const result = cd.wgs84togcj02(markerLnglat.lng, markerLnglat.lat);
      let gcjLng = result[0];
      let gcjLat = result[1];
      this.emitLnglat = { lng: gcjLng, lat: gcjLat };
    },
    saveMarker() {
      if (this.emitLnglat == null) {
        this.$message({
          message: "绘制完成后需要结束绘制，才能保存数据",
          type: "warning",
        });
      } else {
        console.log("saveMarker", this.emitLnglat);
        this.$emit("getLnglat", this.emitLnglat);
        this.$emit("cancel");
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    async searchGeoCode() {
      try {
        // 天地图地理编码服务接口URL，根据具体接口调整
        const url = `/tdt/geocoder?ds={keyWord:${this.loactionInputValue}}&tk=${this.tk}`;

        const response = await axios({
          method: "get",
          url,
          // params: {
          //   ds: {
          //     keyWord: this.loactionInputValue,
          //   }, // 输入的地址
          //   tk: this.tk, // 天地图密钥，请到官网申请
          // },
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.status === 200 && response.data.status === 0) {
          // 假设返回的数据结构包含经纬度信息，具体根据天地图返回的数据结构来解析
          this.locationData = {
            lng: response.data.result.location.lng, // 经度
            lat: response.data.result.location.lat, // 纬度
          };
        } else {
          throw new Error("查询失败：" + response.data.msg);
        }
      } catch (error) {
        console.error(error);
        this.locationData = null;
        alert("地理编码查询失败");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
};
</script>
<style lang="scss" scoped>
.map-wrap {
  width: 100%;
  height: 100%;
  .action-row-wrap {
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .search-box {
      width: 300px;
    }
  }
  .map-footer {
    width: 100%;
    height: 40px;
    margin-top: 10px;
    .btn-box {
      float: right;
    }
  }
  .map-container {
    width: 100%;
    height: calc(100% - 80px);
  }
}
</style>
